/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { RefObject, useEffect } from 'react'
import { Field, Form, Formik, FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { serviceAPI, useChangeBillingCycleMutation } from 'api/service'
import { aud } from 'helpers/utils'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    form: RefObject<FormikProps<{ billing_cycle_id: number }>>,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function BillingCycleForm({ id, form, close }: Props) {
    const { data } = serviceAPI.endpoints.billingCycle.useQueryState(id)
    const { data: service = { billing_cycle: { id: 0 } } } = serviceAPI.endpoints.service.useQueryState(id)
    const [changeBillingCycle, { isLoading, isSuccess }] = useChangeBillingCycleMutation()
    const billingCycle = data?.map(({ price, billing_cycle }) => ({
        value: billing_cycle.id,
        label: `${billing_cycle.name} - ${aud(price)}`
    }))

    /**********************************************************************************************************
     *   SIDE EFFECTS
     //  **********************************************************************************************************/
    useEffect(() => {
        if (isSuccess && form.current) {
            form.current.setSubmitting(false)
            form.current.resetForm()
            close()
        }
    }, [form, isLoading, isSuccess])

    return (
        <Formik
            innerRef={form}
            initialValues={{
                billing_cycle_id: service.billing_cycle.id
            }}
            onSubmit={({ billing_cycle_id }) => {
                changeBillingCycle({ id, billing_cycle_id })
            }}
        >
            {() => (
                <Form id={'changeBillingCycleForm'}>
                    <Field
                        label={'Billing Cycle'}
                        name={'billing_cycle_id'}
                        type={'select'}
                        disabled={isLoading}
                        list={billingCycle}
                        component={NXUIForm.SelectField}
                    />
                </Form>
            )}
        </Formik>
    )
}
